import React from "react";

const PRRow = (props) => {
  const { title = "" } = props;
  return (
    <div className="pr-row">
      <div className="card-title">{title}</div>
      {props.children}
    </div>
  );
};

export default PRRow;
